export default __webpack_public_path__ + "static/4-7287c8d3c52fb9b92788e5ebc01278ba.png";